<ng-container *ngIf="ready && items && items.length">
  <form class="formContent mw568 indent">
    <app-content-repeater [items]="items"></app-content-repeater>
  </form>
</ng-container>
